export const QUERY_KEYS = Object.freeze({
  CATEGORY_LIST_POLICY: 'CATEGORY_LIST_POLICY',
  CATEGORY_LIST_ENTERPRISE: 'CATEGORY_LIST_ENTERPRISE',
  CATEGORY_LIST: 'CATEGORY_LIST',
  CATEGORY_DETAIL: 'CATEGORY_DETAIL',
  ARTICLE_LIST: 'ARTICLE_LIST',
  EVENT_LIST: 'EVENT_LIST',
  DELETE_EVENT_LIST: 'DELETE_EVENT_LIST',
  EDIT_EVENT_ADMIN: 'EDIT_EVENT_ADMIN',
  EVENT_PRIZE_HISTORY: 'EVENT_PRIZE_HISTORY',
  EVENT_DETAIL: 'EVENT_DETAIL',
  REGISTER_EVENT: 'REGISTER_EVENT',
  DOCUMENT_LIST: 'DOCUMENT_LIST',
  PRODUCT_CODE: 'PRODUCT_CODE',
  ADMIN: 'ADMIN_LIST',
  ADD_NEW_ADMIN: 'ADD_NEW_ADMIN',
  EDIT_ADMIN: 'EDIT_ADMIN',
  SHOP_INVITATION_LIST: 'SHOP_INVITATION_LIST',
  SHOP_INVITATION_EXPORTCSV: 'SHOP_INVITATION_EXPORTCSV',
  STORE_ADMIN: 'STORE_ADMIN',
  EVENT_LIST_PRIZE: 'EVENT_LIST_PRIZE',
  EVENT_CREATE_PRIZE: 'EVENT_CREATE_PRIZE',
  EVENT_GET_TRANSACTION: 'EVENT_GET_TRANSACTION',
  EVENT_GET_PROVINCE: 'EVENT_GET_PROVINCE',
  EVENT_PRIZE_DETAIL: 'EVENT_PRIZE_DETAIL',
  ALL_TRANSACTION_TYPE: 'ALL_TRANSACTION_TYPE',
  ALL_PROVINCE_VN: 'ALL_PROVINCE_VN',
  LIST_GIFT: 'LIST_GIFT',
  GIFT_DETAIL: 'GIFT_DETAIL',
  HISTORY_WINNING: 'HISTORY_WINNING',
  LIST_EVENT: 'LIST_EVENT',
  LIST_CODE: 'LIST_CODE',
  GET_EDIT_CODE: 'GET_EDIT_CODE',
  EDIT_CODE: 'EDIT_CODE',
  POST_CODE: 'POST_CODE',
  MERCHANT_INFO: 'MERCHANT_INFO',
  GET_GIFT_LIST: 'GET_GIFT_LIST',
  GET_WHEEL_DETAIL: 'GET_WHEEL_DETAIL',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  LIST_PRODUCT: 'LIST_PRODUCT',
  GET_PRODUCT_BY_ID: 'GET_PRODUCT_BY_ID',
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  NEW_PRODUCT: 'NEW_PRODUCT',
  LIST_PRODUCT_ATTRIBUTE: 'LIST_PRODUCT_ATTRIBUTE',
  POST_PRODUCT_ATTRIBUTE: 'POST_PRODUCT_ATTRIBUTE',
  EDIT_PRODUCT_ATTRIBUTE: 'EDIT_PRODUCT_ATTRIBUTE',
  DELETE_PRODUCT_ATTRIBUTE: 'DELETE_PRODUCT_ATTRIBUTE',
  CATEGORY_PRODUCT: 'CATEGORY_PRODUCT',
  TAG_PRODUCT: 'TAG_PRODUCT',
  LIST_PRODUCT_CATEGORY: 'LIST_PRODUCT_CATEGORY',
  LIST_PRODUCT_TAG: 'LIST_PRODUCT_TAG',
  LIST_PRODUCT_ATTRIBUTE_TERM: 'LIST_PRODUCT_ATTRIBUTE_TERM',
  LIST_PRODUCT_ATTRIBUTE_TERM_MANUAL: 'LIST_PRODUCT_ATTRIBUTE_TERM_MANUAL',
  EDIT_PRODUCT_TERM: 'EDIT_PRODUCT_TERM',
  VARIANT_PRODUCT: 'VARIANT_PRODUCT',
  NEW_PRODUCT_ATTRIBUTE_TERM: 'NEW_PRODUCT_ATTRIBUTE_TERM',
  NEW_PRODUCT_VARIANT: 'NEW_PRODUCT_VARIANT',
  LIST_PRODUCT_VARIANT: 'LIST_PRODUCT_VARIANT',
  DETAIL_PRODUCT_VARIANT: 'DETAIL_PRODUCT_VARIANT',
  EDIT_PRODUCT_VARIANT: 'EDIT_PRODUCT_VARIANT',
  LIST_HOME_CONFIG: 'LIST_HOME_CONFIG',
  LIST_ORDER: 'LIST_ORDER',
  GET_ORDER_BY_ID: 'GET_ORDER_BY_ID',
  GET_EXTERNAL: 'GET_EXTERNAL',
  LIST_CONFIG_FEATURE: 'LIST_CONFIG_FEATURE',
  LIST_CONFIG_EVENT: 'LIST_CONFIG_EVENT',
  NEW_POINT: 'NEW_POINT',
  LIST_POINT: 'LIST_POINT',
  EDIT_POINT: 'EDIT_POINT',
  REQUEST_BY_ID: 'REQUEST_BY_ID',
  REQUEST_LIST: 'REQUEST_LIST',
  DOWNLOAD_HISTORY_LIST: 'REQUEST_LIST',
  LIST_SURVEYS: 'LIST_SURVEYS',
  CREATE_SURVEY: 'CREATE_SURVEY',
  EDIT_SURVEY: 'EDIT_SURVEY',
  LIST_FEEDBACK: 'LIST_FEEDBACK',
  SPOON_CODE: 'SPOON_CODE',
  SBPS_CODE: 'SBPS_CODE',
  LIST_WEIGHT: 'LIST_WEIGHT',
  LIST_PRODUCT_GROUP: 'LIST_PRODUCT_GROUP',
  LIST_CODE_SBPS: 'LIST_CODE_SBPS',
  QR_CODE_LIST: 'QR_CODE_LIST',
  CHANGE_STATUS_QR_CODE: 'CHANGE_STATUS_QR_CODE',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  GET_MOBILE_ROUTE: 'GET_MOBILE_ROUTE',
  GET_LIST_AGENT: 'GET_LIST_AGENT',
  NEW_AGENT: 'NEW_AGENT',
  DETAIL_AGENT: 'DETAIL_AGENT',
  PUT_AGENT: 'PUT_AGENT',
  LIST_GROUP_POLICY: 'LIST_GROUP_POLICY',
  LIST_POPUP: 'LIST_POPUP',
  CREATE_POPUP: 'CREATE_POPUP',
  DETAIL_POPUP: 'DETAIL_POPUP',
  EDIT_POPUP: 'EDIT_POPUP',
  LIST_USER: 'LIST_USER',
  USER_BY_ID: 'USER_BY_ID',
  CHANGE_USER_STATUS_ADD_POINT: 'CHANGE_USER_STATUS_ADD_POINT',

  GET_HOME_CONFIG_DATA: 'GET_HOME_CONFIG_DATA',
  GET_CUSTOMER_PRODUCT_FOR_PREVIEW: 'GET_CUSTOMER_PRODUCT_FOR_PREVIEW',
  NEW_CATEGORY: 'NEW_CATEGORY',
  NEW_TAG: 'NEW_TAG',
  GET_PRODUCT_LIST_WHEEL: 'GET_PRODUCT_LIST_WHEEL',
  LIST_TIER_RANK: 'LIST_TIER_RANK',
  EDIT_TIER_RANK: 'EDIT_TIER_RANK',
  DETAIL_TIER_RANK: 'DETAIL_TIER_RANK',
  ORDER_DELIVERY: 'ORDER_DELIVERY',
  GET_PROVINCES: 'GET_PROVINCES',
  GET_DISTRICT: 'GET_DISTRICT',
  GET_SHOP: 'GET_SHOP',
  GET_SERVICES: 'GET_SERVICES',
  LIMIT_SPOON_CODE: ' LIMIT_SPOON_CODE',
  GET_LIST_POLICIES: 'GET_LIST_POLICIES',
  GROUP_POLICIES_CURRENT: 'GROUP_POLICIES_CURRENT',
  LIST_TAG: 'LIST_TAG',
  TAG_DETAIL: 'TAG_DETAIL',
  LIST_CATEGORY: 'LIST_CATEGORY',
  EDIT_CATEGORY: 'EDIT_CATEGORY',
  CATEGORY_BY_ID: 'CATEGORY_BY_ID',
  REQUEST_EXPORT_LIST: 'REQUEST_EXPORT_LIST',
  LIST_GROUP_USER: 'LIST_GROUP_USER',
  CREATE_GROUP_USER: 'CREATE_GROUP_USER',
  EDIT_GROUP_USER: 'EDIT_GROUP_USER',
  GROUP_USER_BY_ID: 'GROUP_USER_BY_ID',
  EDIT_USER: 'EDIT_USER',
  LIST_EXTERNAL_REFERRER: 'LIST_EXTERNAL_REFERRER',
  DETAIL_EXTERNAL_REFERRER: 'DETAIL_EXTERNAL_REFERRER',
  LIST_NOTIFICATIONS: 'LIST_NOTIFICATIONS',
  EDIT_NOTIFICATION: 'EDIT_NOTIFICATION',
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  NOTIFICATION_BY_ID: 'NOTIFICATION_BY_ID',
  ROUTE_MOBILE: 'ROUTE_MOBILE',
  USER_SURVEY: 'USER_SURVEY',
  DETAIL_USER_SURVEY: 'DETAIL_USER_SURVEY',
  LIST_TERM_POLICY: 'LIST_TERM_POLICY',
  TERM_POLICY: 'TERM_POLICY',
  CREATE_TERM_POLICY: 'CREATE_TERM_POLICY',
  UPDATE_TERM_POLICY: 'UPDATE_TERM_POLICY',
  LIST_NEWS: 'LIST_NEWS',
  GET_NEWS_BY_ID: 'GET_NEWS_BY_ID',
  LIST_NEWS_SUBJECT: 'LIST_NEWS_SUBJECT',
  NEWS_SUBJECT: 'NEWS_SUBJECT',
  NEW_SUBJECT: 'NEW_SUBJECT',
  GET_NEWS_SUBJECT_BY_ID: 'GET_NEWS_SUBJECT_BY_ID',
  EDIT_SUBJECT: 'EDIT_SUBJECT',
  REQUEST_IMPORT_LIST: 'REQUEST_IMPORT_LIST',
  LIST_HISTORY_SCAN: 'LIST_HISTORY_SCAN',
  GET_DISTRICT_CUSTOMER: 'GET_DISTRICT_CUSTOMER',
  GET_WARD_CUSTOMER: 'GET_WARD_CUSTOMER',
  GET_LIST_PROVINCE: 'GET_PROVINCE',
  GET_LIST_PROVINCE_MERCHANT: 'GET_LIST_PROVINCE_MERCHANT',
  HISTORY_GIFT: 'HISTORY_GIFT',
  RULE_CONFIG: 'RULE_CONFIG',
  EDIT_RULE_CONFIG: 'EDIT_RULE_CONFIG',

  TYPE_GAME: 'TYPE_GAME',
  LIST_GAME: 'LIST_GAME',
  EDIT_GAME: 'EDIT_GAME',
  DETAIL_GAME: 'DETAIL_GAME',
  LIST_REFUND_ORDER: 'LIST_REFUND_ORDER',
  LIST_REFUND_ORDER_REQUEST: 'LIST_REFUND_ORDER_REQUEST',
  REFUND_ORDER_BY_ID: 'REFUND_ORDER_BY_ID',
  LIST_STORE_IN_MAP: 'LIST_STORE_IN_MAP',
  STORE_IN_MAP_DETAIL: 'STORE_IN_MAP_DETAIL',
  GAME_GIFTS: 'GAME_GIFTS',
  GAME_GIFTS_BY_ID: 'GAME_GIFTS_BY_ID',
  PRODUCT_VARIANTS: 'PRODUCT_VARIANTS',
  CREATE_EVENT: 'CREATE_EVENT',
  EDIT_EVENT: 'EDIT_EVENT',
  EVENT_BY_ID: 'EVENT_BY_ID',
  LIST_GAME_CONFIG_PLAYTIME: 'LIST_GAME_CONFIG_PLAYTIME',
  LIST_APP_CONFIG: 'LIST_APP_CONFIG',
  GET_LIST_PRODUCT_GROUP: 'GET_LIST_PRODUCT_GROUP',
  LIST_USER_INTRODUCE: 'LIST_USER_INTRODUCE',
  GET_PRODUCT_VIRTUAL: 'GET_PRODUCT_VIRTUAL',
  GET_PRODUCT_VIRTUAL_BY_ID: 'GET_PRODUCT_VIRTUAL_BY_ID',
  STATISTIC_POINT_CIRCLE: 'STATISTIC_POINT_CIRCLE',
  STATISTIC_POINT_LINE: 'STATISTIC_POINT_LINE',
  STATISTIC_SPOON_CIRCLE: 'STATISTIC_SPOON_CIRCLE',
  STATISTIC_SPOON_LINE: 'STATISTIC_SPOON_LINE',
  STATISTIC_SCAN_CIRCLE: 'STATISTIC_SCAN_CIRCLE',
  STATISTIC_SCAN_LINE: 'STATISTIC_SCAN_LINE',

  ORDER_PIE_CHART: 'ORDER_PIE_CHART',
  GAME_PIE_CHART: 'GAME_PIE_CHART',

  ORDER_LINE_CHART: 'ORDER_LINE_CHART',
  GAME_LINE_CHART: 'GAME_LINE_CHART',

  GET_LIST_PROVINCE_SCAN: 'GET_PROVINCE_SCAN',
  GET_SHARE_APP_CONFIG: 'GET_SHARE_APP_CONFIG',
  GET_MOBILE_ROUTES: 'GET_MOBILE_ROUTES',

  GET_LIST_DUPLICATE_SCAN: 'GET_LIST_DUPLICATE_SCAN',
  ACTIVE_DUPLICATE_SCAN: 'ACTIVE_DUPLICATE_SCAN',

  GET_EXTERNAL_REF_HISTORY: 'GET_EXTERNAL_REF_HISTORY',
});
